import React from 'react'
import PropTypes from 'prop-types'
import { ListCard } from '~/components/ListCard'
import {
  EXPLORE_FEED_ITEM_TAPPED,
  EXPLORE_FEED_ITEM_VIEWED,
  EXPLORE_FEED_SEE_ALL_CLICKED,
} from '~/lib/tracking-events'
import { decodeGlobalId } from '~/utils/id'
import ViewportTracking from '~/components/ViewportTracking'
import { track } from '~/utils'
import { groupCollectionPropTypes } from '~/graphql/fragments/groupCollection'

const GroupCollectionCard = ({ t, groupCollection, itemOrder }) => {
  const { id, status, title, subtitle, numberOfItemsOnFeedOverview, group } = groupCollection
  const { items = {} } = group
  const { edges: groupItems = [] } = items
  const employeeOnly = status === 'PREVIEW'

  const trackClick = eventId => {
    track(EXPLORE_FEED_ITEM_TAPPED, {
      itemId: decodeGlobalId(id),
      eventId,
      itemOrder,
      itemType: groupCollection.type,
      title,
    })
  }

  const trackSeeAll = () => {
    track(EXPLORE_FEED_SEE_ALL_CLICKED, {
      itemId: decodeGlobalId(id),
      itemOrder,
      itemType: groupCollection.type,
      title,
    })
  }

  return (
    <ViewportTracking
      event={EXPLORE_FEED_ITEM_VIEWED}
      payload={{
        itemId: decodeGlobalId(id),
        itemOrder,
        itemType: groupCollection.type,
        title,
      }}
    >
      <ListCard
        t={t}
        title={title}
        text={subtitle}
        variant="NO_THUMBNAIL"
        dialogItems={groupItems}
        employeeOnly={employeeOnly}
        numberOfItemsOnCard={numberOfItemsOnFeedOverview}
        trackClick={trackClick}
        trackSeeAll={trackSeeAll}
      />
    </ViewportTracking>
  )
}

GroupCollectionCard.propTypes = {
  t: PropTypes.func.isRequired,
  groupCollection: groupCollectionPropTypes.isRequired,
  itemOrder: PropTypes.number.isRequired,
}

export default GroupCollectionCard
